/* =========================================================
 * Appstle Subscription — доработка виджета под Figma-макет.
 *
 * Виджет рендерится скриптом приложения Appstle, поэтому его
 * HTML нельзя править в файлах темы. Здесь мы его дополняем:
 *   • вставляем 3 карточки-фичи (их нет в данных виджета);
 *   • переразмечаем подзаголовок и чек-лист для стилизации;
 *   • заменяем заголовки опций на тексты из макета.
 *
 * Стили — в assets/base.css, блок «APPSTLE SUBSCRIPTION WIDGET».
 * ========================================================= */
(function () {
  'use strict';

  /* --- Дефолты на случай, если конфига из секции нет.
   *     icon: energy | delivery | unlimited (иконки в assets/). --- */
  var DEFAULTS = {
    titleSubscription: 'Unlimited Sessions with Afina',
    titleOneTime: 'One Reading Only',
    deliveryLabel: 'Receive your reading by',
    features: [
      { icon: 'energy',    title: 'Your Energy Profile Report',     was: '$80.00' },
      { icon: 'delivery',  title: '12-Hour Reading Delivery',       was: '$10.00' },
      { icon: 'unlimited', title: 'Unlimited Readings for 30 Days', was: '$99.00' }
    ]
  };

  /* --- Читаем настройки из Theme Editor (JSON-тег рядом со скриптом). --- */
  function readConfig() {
    var node = document.querySelector('[data-appstle-enhance-config]');
    if (!node) { return DEFAULTS; }
    try {
      var cfg = JSON.parse(node.textContent || '{}');
      return {
        titleSubscription: cfg.titleSubscription || DEFAULTS.titleSubscription,
        titleOneTime: cfg.titleOneTime || DEFAULTS.titleOneTime,
        deliveryLabel: cfg.deliveryLabel || DEFAULTS.deliveryLabel,
        features: (cfg.features && cfg.features.length) ? cfg.features : DEFAULTS.features
      };
    } catch (e) {
      return DEFAULTS;
    }
  }

  var CONFIG = readConfig();
  var FEATURES = CONFIG.features;

  /* --- Заголовки опций под макет. '' — оставить текст Appstle. --- */
  var TITLE_SUBSCRIPTION = CONFIG.titleSubscription;
  var TITLE_ONE_TIME     = CONFIG.titleOneTime;

  function elem(tag, cls) {
    var node = document.createElement(tag);
    if (cls) { node.className = cls; }
    return node;
  }

  function divider() { return elem('div', 'afina-sub__divider'); }

  function buildFeatures() {
    var row = elem('div', 'afina-sub__features');
    FEATURES.forEach(function (f) {
      var card = elem('div', 'afina-feat');

      var badge = elem('span', 'afina-feat__badge');
      badge.appendChild(document.createTextNode('FREE '));
      var was = document.createElement('s');
      was.textContent = f.was;
      badge.appendChild(was);

      var icon = elem('span', 'afina-feat__icon afina-feat__icon--' + f.icon);

      var title = elem('span', 'afina-feat__title');
      title.textContent = f.title;

      card.appendChild(badge);
      card.appendChild(icon);
      card.appendChild(title);
      row.appendChild(card);
    });
    return row;
  }

  /* Заменяем содержимое блока описания плана размеченной структурой */
  function enhanceDescription(subOption) {
    var desc = subOption.querySelector('.appstleSellingPlanDescription');
    if (!desc || desc.getAttribute('data-afina-done') === '1') { return; }

    /* Пункты чек-листа Appstle хранит как <span> внутри описания */
    var items = [];
    desc.querySelectorAll('span').forEach(function (sp) {
      var text = (sp.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) { items.push(text); }
    });
    /* Контент ещё не отрисован — ждём следующей мутации */
    if (items.length === 0) { return; }

    /* Подзаголовок — первый листовой блок без <span> */
    var subtitle = '';
    desc.querySelectorAll('div, p').forEach(function (block) {
      if (subtitle) { return; }
      if (block.querySelector('span') || block.querySelector('div, p')) { return; }
      var text = (block.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) { subtitle = text; }
    });

    while (desc.firstChild) { desc.removeChild(desc.firstChild); }

    if (subtitle) {
      var sub = elem('div', 'afina-sub__subtitle');
      sub.textContent = subtitle;
      desc.appendChild(sub);
      desc.appendChild(divider());
    }

    desc.appendChild(buildFeatures());
    desc.appendChild(divider());

    var list = elem('ul', 'afina-sub__checklist');
    items.forEach(function (text) {
      var li = elem('li', 'afina-sub__check');
      li.appendChild(elem('span', 'afina-check'));
      var label = elem('span', 'afina-sub__checktext');
      label.textContent = text;
      li.appendChild(label);
      list.appendChild(li);
    });
    desc.appendChild(list);

    desc.setAttribute('data-afina-done', '1');
  }

  function applyTitles(widget) {
    if (TITLE_SUBSCRIPTION) {
      var sub = widget.querySelector('.appstle_subscribe_save_text');
      if (sub && sub.textContent.trim() !== TITLE_SUBSCRIPTION) {
        sub.textContent = TITLE_SUBSCRIPTION;
      }
    }
    if (TITLE_ONE_TIME) {
      var one = widget.querySelector('.appstle_one_time_text');
      if (one && one.textContent.trim() !== TITLE_ONE_TIME) {
        one.textContent = TITLE_ONE_TIME;
      }
    }
  }

  /* --- Блок "Receive your reading by [завтрашняя дата]" --- */
  function nextDayText() {
    var d = new Date();
    d.setDate(d.getDate() + 1);
    return d.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
  }

  function injectDeliveryDate(widget) {
    var existing = widget.querySelector('.afina-delivery');
    if (existing) {
      var dateEl = existing.querySelector('.afina-delivery__date');
      if (dateEl) { dateEl.textContent = nextDayText(); }
      return;
    }
    var row = elem('div', 'afina-delivery');
    var label = elem('div', 'afina-delivery__label');
    label.appendChild(elem('span', 'afina-delivery__icon'));
    var text = elem('span', 'afina-delivery__text');
    text.textContent = CONFIG.deliveryLabel;
    label.appendChild(text);
    var date = elem('div', 'afina-delivery__date');
    date.textContent = nextDayText();
    row.appendChild(label);
    row.appendChild(date);

    var wrapper = widget.querySelector('.appstle_subscription_wrapper');
    if (wrapper && wrapper.parentNode) {
      wrapper.parentNode.insertBefore(row, wrapper.nextSibling);
    } else {
      widget.appendChild(row);
    }
  }

  function enhance() {
    var widget = document.querySelector('.appstle_sub_widget');
    if (!widget) { return; }

    var subOption = widget.querySelector('.payAsYouGoPlansDropdownWrapper') ||
                    widget.querySelector('.appstle_subscription_wrapper_option.appstle_include_dropdown');
    if (subOption) { enhanceDescription(subOption); }
    applyTitles(widget);
    injectDeliveryDate(widget);
  }

  /* --- Запуск и наблюдение за перерисовкой виджета Appstle --- */
  var observer = null;
  var scheduled = false;
  var startedAt = Date.now();

  function schedule() {
    if (scheduled) { return; }
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      if (observer) { observer.disconnect(); }
      try { enhance(); } catch (e) { /* тихо игнорируем */ }
      /* Перестаём наблюдать, если виджет так и не появился за 20 c */
      var keepWatching = document.querySelector('.appstle_sub_widget') ||
                         Date.now() - startedAt < 20000;
      if (observer && keepWatching) {
        observer.observe(document.body, { childList: true, subtree: true });
      }
    });
  }

  /* --- Клик по всей карточке опции выбирает её (не только radio/заголовок) --- */
  function setupCardClick() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) { return; }
      var card = t.closest('.appstle_subscription_wrapper_option');
      if (!card) { return; }
      /* по самому radio/label или интерактивному элементу — нативное поведение */
      if (t.closest('label, input, select, a, button')) { return; }
      var radio = card.querySelector('input[type="radio"][name="selling_plan"]');
      if (!radio || radio.checked) { return; }
      /* клик по label = то же, что нажатие на заголовок (Appstle реагирует штатно) */
      var label = card.querySelector('label.appstle_radio_label');
      (label || radio).click();
    });
  }

  function init() {
    enhance();
    setupCardClick();
    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
